import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Td } from './css';
import getFormattedPricing from '../../utils';

const Row = ({
  rowData,
  viewType,
  additionalServices,
  setAdditionalServices
}) => {
  const {
    fields: { addonName, unitPrice }
  } = rowData;

  const [quantity, setQuantity] = useState(() =>
    _.get(additionalServices, `${addonName}.quantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    const updatedRatePlans = {
      ...additionalServices,
      [addonName]: {
        quantity,
        unitPrice
      }
    };
    setAdditionalServices(updatedRatePlans);
  }, [quantity, unitPrice]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  return (
    <tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>{addonName}</Td>
      <Td>
        <input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={e => {
            setQuantity(+e.target.value);
          }}
        />
      </Td>
      <Td>{getFormattedPricing(unitPrice)}</Td>
      <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
    </tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      addonName: PropTypes.string,
      unitPrice: PropTypes.number
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  additionalServices: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAdditionalServices: PropTypes.func.isRequired
};

export default Row;
